import axios from '../../axios'
import { makeObservable } from 'mobx'
import { ObjectType } from './types'
// import { toast } from 'react-toastify'

export class ObjectStore {
  constructor() {
    makeObservable(this, {})
  }

  reset = () => {}

  forceFailure = async (objectType: ObjectType | string, objectId: number, message: string) => {
    return await axios.put(`/api/v1/object/${objectType}/${objectId}/failure`, { message })
  }

  forceSuccess = async (objectType: ObjectType | string, objectId: number, message: string) => {
    return await axios.put(`/api/v1/object/${objectType}/${objectId}/success`, { message })
  }
}

export const objectStore = new ObjectStore()
